// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'scale-down';

export const Component = () => (
  <path d='M23.5 17.244c0 .326-.186.512-.512.512h-4.289v4.279c0 .325-.14.465-.466.465s-.466-.14-.466-.465v-4.79c0-.326.14-.466.466-.466h4.755c.326 0 .512.14.512.465Zm-5.267-9.022h4.755c.326 0 .512-.14.512-.466 0-.325-.186-.51-.512-.51h-4.289v-4.28c0-.326-.14-.465-.466-.465s-.466.14-.466.465v4.79c0 .326.14.466.466.466ZM6.767 16.779H2.012c-.326 0-.512.14-.512.465 0 .326.186.512.512.512h4.289v4.279c0 .325.14.465.466.465s.466-.14.466-.465v-4.79c0-.326-.14-.466-.466-.466Zm.466-13.814c0-.325-.14-.465-.466-.465s-.466.14-.466.465v4.28H2.012c-.326 0-.512.185-.512.51 0 .326.186.466.512.466h4.755c.326 0 .466-.14.466-.465v-4.79Z' />
);

export const viewBox = '0 0 25 25';
